import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import ModalHeaderWithActions from './ModalHeaderWithActions';
import { useTranslation } from "react-i18next";

interface AddCommentProps {
    show: boolean;
    title: string;
    onClose: (comment: string | null) => void; // null = canceled
}

const AddComment: React.FC<AddCommentProps> = ({ show, title, onClose }) => {
    const { t } = useTranslation("candidate_portal");
    const [comment, setComment] = useState('');

    return (
        <Modal show={show} onHide={() => onClose(null)} backdrop="static" className="change-modal">
            <ModalHeaderWithActions
                title={title}
                onClose={() => onClose(null)}
                onSubmit={() => onClose(comment)}
                canSubmit={true}
                isInEditMode={false}
            />
            <Modal.Body>
                <Form.Control
                    as="textarea"
                    id="formDescription"
                    rows={3}
                    className="form-control-input-custom mb-4"
                    placeholder={t("common:form.placeholders.giveReasonFeedback")}
                    onChange={(e) => setComment(e.target.value)}
                    value={comment}
                />
                <Button variant="primary" onClick={() => onClose(comment)}>
                    {t("jobOffer.send")}
                </Button>
            </Modal.Body>
        </Modal>
    );
};

// Hook to use the confirm dialog
export const useAddComment = () => {
    const [show, setShow] = useState(false);
    const [dialogConfig, setDialogConfig] = useState({ title: '' });
    const [resolver, setResolver] = useState<((value: string | null) => void) | null>(null);

    const showAddComment = (title: string): Promise<string | null> => {
        setShow(true);
        setDialogConfig({ title });

        return new Promise((resolve) => {
            setResolver(() => resolve);
        });
    };

    const handleClose = (msg: string | null) => {
        setShow(false);
        if (resolver) {
            resolver(msg);
            setResolver(null);
        }
    };

    const AddCommentComponent = () => (
        <AddComment
            show={show}
            title={dialogConfig.title}
            onClose={handleClose}
        />
    );

    return { showAddComment, AddCommentComponent };
};

// Usage example:
//const { showAddComment, AddCommentComponent } = useAddComment();

//const handleShow = async () => {
//    const comment = await showAddComment("Add your feedback");
//    if (comment) {
//        console.log("User entered:", comment);
//    } else {
//        console.log("User canceled");
//    }
//};

//return (
//    <>
//        <AddCommentComponent />
//        <Button onClick={handleShow}>Show</Button>
//    </>
//);